/* eslint-disable no-unused-vars */
/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
/* eslint-disable comma-dangle */
// CONSTANTS are all caps.
const NS = 'MagnifyingGallery';
const CLS = 'magnifyingGallery';
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/magnifyingGallery.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class MagnifyingGallery {
	constructor($el) {
		// $el is the widget node return by the loadMagnifyingGallery function
		this.$el = $($el);
	}

	init() {
		const This = this;
		const $wg = this.$el;
		let images = $wg.find(`${WG}slideImg`);

		// no images are loaded.
		let imagesLoaded = 0;
		// total number of images in the slider
		let totalImages = images.length;

		images.each(function() {
			let imgSrc = $(this).attr('src');
			let objImg = new Image();
			objImg.src = imgSrc;
			objImg.onload = function() {
				imagesLoaded++;
				if (imagesLoaded == totalImages) {
					This.initCarousel();
					This.initMagnify();
				}
			};
		});
	}

	initCarousel() {
		const $carousel = this.$el.find(`${WG}carousel`);
		const $wg = this.$el;
		let navActiveClass = 'is-active';

		$carousel.on('init', () => {
			this.$el.find('.sliderNav-link').on('click', function() {
				let $this = $(this);
				let index = $this.attr('data-slide-index');

				$carousel.slick('slickGoTo', index);
				$this.siblings().removeClass(navActiveClass);
				$this.addClass(navActiveClass);

				// detach the line and put it before the active item
				let $sliderNavLine = $wg.find('.sliderNav-line').detach();
				$this.before($sliderNavLine);
			});
		}).slick({
			appendArrows: this.$el.find(`${WG}carouselNav`),
			nextArrow: '<i class="icon-chevron-right"></i>',
			prevArrow: '<i class="icon-chevron-left"></i>',
			draggable: false,
			responsive: [
				{
					breakpoint: 1142,
					settings: {
						arrows: false,
						dots: true
					}
				}
			]
		}).on('afterChange', (event, slick, currentSlide) => {
			let $sliderNavLine = $wg.find('.sliderNav-line').detach();
			this.$el.find('.sliderNav-link').removeClass(navActiveClass);
			this.$el.find(`.sliderNav-link[data-slide-index=${currentSlide}]`).addClass(navActiveClass).before($sliderNavLine);
		});
	}

	initMagnify() {
		this.$el.find(`${WG}slideImg`).magnify({
			limitBounds: true,
			mobileCloseEvent: 'click'
		});
	}
}
